import type { Color } from '@/global/components/Logo/Logo'
import type { StaticImageData } from 'next/image'

export const logoBlack = '/images/logo/black.png'
export const logoWhite = '/images/logo/white.png'

export const colorMap = new Map<Color, string | StaticImageData>([
  ['on-dark', logoWhite],
  ['on-light', logoBlack]
])

export const altMap = new Map<Color, string>([
  ['on-dark', 'Logo da Alice - Alice escrito com letra cursiva na cor branco'],
  ['on-light', 'Logo da Alice - Alice escrito com letra cursiva na cor preto']
])
